import { LifeBuoy } from "lucide-react";
import { useSupport } from "../contexts/SupportContext";

export default function SupportButton() {
  const { openSupport } = useSupport();
  return (
    <button
      type="button"
      onClick={() => openSupport()}
      className="fixed bottom-5 right-5 z-40 h-12 w-12 rounded-full shadow-lg btn-gradient flex items-center justify-center hover:scale-105 transition-transform"
      title="Contacter le support"
      aria-label="Contacter le support"
      data-testid="support-floating-btn"
    >
      <LifeBuoy className="h-5 w-5 text-white" />
    </button>
  );
}
